export default __webpack_public_path__ + "static/media/LogoUsiminas.29266acc.svg";